"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _images = require("../common_features/assets/images");
var _helper = require("../common_features/utility/helper");
var _EditSensorComponent = _interopRequireDefault(require("../components/EditSensorComponent"));
const EditHub = props => {
  const {
    selectedGateway
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const handleBackToStore = () => {
    navigate(-1);
  };
  return /*#__PURE__*/_react.default.createElement(_EditSensorComponent.default, {
    handleBack: handleBackToStore,
    leftArrow: _images.leftArrow.default,
    backNavigationScreen: "System Dashboard",
    editSensorText: "Edit Hub",
    subText: "Are you making any changes to this Hub?",
    installationDateText: "Installation Date",
    moveSensorButtonText: "Save",
    installationDate: (0, _helper.getDate)(selectedGateway.createdAt),
    serialNumberText: "Serial Number",
    serialNumber: selectedGateway.deviceId,
    sensorImage: selectedGateway.gatewayImageUrl,
    removeSensorButtonText: "Remove Hub",
    btnType: "gateway",
    isPrimary: false,
    isSecondary: true,
    onClickMoveSensor: handleBackToStore,
    onClickRemoveSensor: null,
    removeSensorButtonDisable: true
  });
};
var _default = exports.default = EditHub;